import _slicedToArray from "/Users/Ryan/Dropbox/WebsiteDevelopment/Lasalle Heating/liveSite/gatsby-serif-theme/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as o, useEffect as t } from "react";
var r = {
  serverHandoffComplete: !1
};

function a() {
  var _o = o(r.serverHandoffComplete),
      _o2 = _slicedToArray(_o, 2),
      e = _o2[0],
      f = _o2[1];

  return t(function () {
    e !== !0 && f(!0);
  }, [e]), t(function () {
    r.serverHandoffComplete === !1 && (r.serverHandoffComplete = !0);
  }, []), e;
}

export { a as useServerHandoffComplete };